<script setup lang="ts">
const items = [
  {
    title: 'Keamanan Berlapis',
    descriptions: [
      'PIN Transaksi unik untuk setiap akun.',
      'OTP WhatsApp sebelum pembayaran dilakukan.',
      'Maksimum 3 kali percobaan PIN untuk perlindungan ekstra.'
    ],
    icon: 'material-symbols:security'
  },
  {
    title: 'Transparansi Total',
    descriptions: [
      'Riwayat transaksi tersimpan otomatis di tab Penggunaan Kredit.',
      'Laporan saldo bisa diakses langsung oleh owner & finance team.'
    ],
    icon: 'material-symbols:find-in-page-outline'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    title="Aman Digunakan, Transparan Dipantau"
    hero-image="/images/ka-kredit-banner-4.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <ul
              class="list-outside list-disc text-sm lg:text-base text-outline ml-4"
            >
              <li v-for="(value, idxDesc) in item.descriptions" :key="idxDesc">
                {{ value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
